import React from 'react'
import Pt from 'prop-types'
import { ControlLabel, FormControl } from 'react-bootstrap'
import cx from 'classnames'

import FormGroup from './FormGroup'
import Icon from '../Icon'

export default function FormField({
  bsSize,
  children,
  controlId,
  controlLabel,
  createDefaultControl = props => <FormControl {...props} />,
  errorKey = controlId,
  feedback,
  loading = false,
  onChange,
  placeholder = controlLabel,
  required = false,
  value,
  ...groupProps
}) {
  if (typeof children === 'function') {
    children = children(createDefaultControl({
      onChange,
      placeholder,
      type: 'text',
      value,
    }))
  } else if (!children) {
    children = createDefaultControl({
      onChange,
      placeholder,
      type: 'text',
      value,
    })
  }

  if (!feedback && loading) {
    feedback = (
      <FormControl.Feedback>
        <Icon name="circle-o-notch" spin fixedWidth />
      </FormControl.Feedback>
    )
  }

  return (
    <FormGroup
      bsSize={bsSize}
      className={cx({
        notProvided: required && !value,
      })}
      controlId={controlId}
      errorKey={errorKey}
      feedback={feedback}
      required={required}
      {...groupProps}
    >
      {controlLabel && <ControlLabel>{controlLabel}</ControlLabel>}

      {children}
    </FormGroup>
  )
}

FormField.propTypes = {
  bsSize: Pt.string,
  children: Pt.oneOfType([Pt.node, Pt.func]),
  controlId: Pt.string,
  controlLabel: Pt.string,
  createDefaultControl: Pt.func,
  errorKey: Pt.string,
  feedback: Pt.node,
  loading: Pt.bool,
  onChange: Pt.func,
  placeholder: Pt.string,
  required: Pt.bool,
  // eslint-disable-next-line react/forbid-prop-types
  value: Pt.any,
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/components/Form/FormField.jsx